/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfinishconnecting2Inputs */

const en_crosspostingfinishconnecting2 = /** @type {(inputs: Crosspostingfinishconnecting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish connecting`)
};

const de_crosspostingfinishconnecting2 = /** @type {(inputs: Crosspostingfinishconnecting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung abschließen`)
};

/**
* | output |
* | --- |
* | "Finish connecting" |
*
* @param {Crosspostingfinishconnecting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfinishconnecting2 = /** @type {((inputs?: Crosspostingfinishconnecting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfinishconnecting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfinishconnecting2(inputs)
	return de_crosspostingfinishconnecting2(inputs)
});
export { crosspostingfinishconnecting2 as "crosspostingFinishConnecting" }